module.exports = __webpack_public_path__ + "img/ryuo.518d4ea9.png";